<template/>
<script>
export default {
  data() {
    let vm = this;
    return {
      element: null,
      resources: {
        zIndex: {
          name: 'zIndex',
          defaultValue: '',
          labelDesc: 'zIndex',
          callback: function() {
            vm.resources.zIndex.defaultValue = this.value;
            vm.element.internal_config.zIndex = this.value;
          },
        },
        maxWidth: {
          name: 'maxWidth',
          defaultValue: '500',
          min: '50',
          max: '768',
          labelDesc: 'max-width',
          callback: function() {
            vm.resources.maxWidth.defaultValue = this.value;
            vm.element.internal_config.maxWidth = this.value + 'px';
          },
        },

        height: {
          name: 'height',
          defaultValue: '300',
          min: '20',
          max: '1000',
          labelDesc: 'height',
          callback: function() {
            vm.resources.height.defaultValue = this.value;
            vm.element.internal_config.height = this.value + 'px';
          },
        },

        heightContainer: {
          name: 'heightContainer',
          defaultValue: '300',
          min: '20',
          max: '1000',
          labelDesc: 'heightContainer',
          callback: function() {
            vm.resources.heightContainer.defaultValue = this.value;
            vm.element.internal_config.heightContainer = this.value + 'px';
          },
        },

        enableOnlyLink: {
          name: 'enableOnlyLink',
          defaultValue: false,
          labelDesc: 'place-menu-enable-link',
          callback: function() {
            vm.resources.enableOnlyLink.defaultValue = this.value;
            vm.element.internal_config.enableOnlyLink = this.value;
          }
        },

        link: {
          name: 'link',
          defaultValue: {
            'type': 'web',
            'value': '',
            'target': '_blank'
          },
          labelDesc: 'link',
          callback: function(data) {
            vm.element.internal_config.link = data;
          },
        },

        widthContainer: {
          name: 'widthContainer',
          defaultValue: '300',
          defaultValueChecked: false,
          min: '20',
          max: '2000',
          canBeCheckbox: false,
          labelCheckbox: 'ct-place-menu-100',
          labelDesc: 'widthContainer',
          callback: function() {
            vm.resources.widthContainer.defaultValue = this.value;
            vm.element.internal_config.widthContainer = this.value + 'px';

            vm.resources.widthContainer.defaultValueChecked = this.valueChecked;
            vm.element.internal_config.widthContainerFull = this.valueChecked;
          },
        },

        // minWidth: {
        //   name: 'minWidth',
        //   defaultValue: '200',
        //   defaultValueChecked: true,
        //   min: '1',
        //   max: '700',
        //   canBeCheckbox: true,
        //   labelCheckbox: 'ct-enable-width-auto',
        //   labelDesc: 'minWidth',
        //   callback: function() {
        //     vm.resources.minWidth.defaultValue = this.value;
        //     vm.element.internal_config.minWidth = this.value + 'px';
        //
        //     vm.resources.minWidth.defaultValueChecked = this.valueChecked;
        //     vm.element.internal_config.enableWidthAuto = this.valueChecked;
        //   },
        // },

        backgroundColorHover: {
          name: 'backgroundColorHover',
          defaultValue: '#ffffff',
          gradient: true,
          labelDesc: 'resource-bg-color-hover',
          callback: function() {
            vm.resources.backgroundColorHover.defaultValue = this.colorValue;
            vm.element.internal_config.backgroundColorHover = this.colorValue;
          },
        },
        textColorHover: {
          name: 'textColorHover',
          defaultValue: '#ffffff',
          labelDesc: 'resource-bg-text-hover',
          callback: function() {
            vm.resources.textColorHover.defaultValue = this.colorValue;
            vm.element.internal_config.textColorHover = this.colorValue;
          },
        },

        backgroundColorSelected: {
          name: 'backgroundColorSelected',
          defaultValue: '#ffffff',
          gradient: true,
          labelDesc: 'resource-bg-color-selected',
          callback: function() {
            vm.resources.backgroundColorSelected.defaultValue = this.colorValue;
            vm.element.internal_config.backgroundColorSelected = this.colorValue;
          },
        },
        textColorSelected: {
          name: 'textColorSelected',
          defaultValue: '#ffffff',
          labelDesc: 'resource-bg-text-selected',
          callback: function() {
            vm.resources.textColorSelected.defaultValue = this.colorValue;
            vm.element.internal_config.textColorSelected = this.colorValue;
          },
        },

        backgroundColor: {
          name: 'backgroundColor',
          defaultValue: '#ffffff',
          gradient: true,
          labelDesc: 'bg-color-header',
          callback: function() {
            vm.resources.backgroundColor.defaultValue = this.colorValue;
            vm.element.internal_config.backgroundColor = this.colorValue;
          },
        },

        border: {
          name: 'border',
          defaultValue: '1px solid black',
          min: '0',
          max: '50',
          labelDesc: 'border',
          callback: function() {
            let value = this.value + 'px ' + this.value2 + ' ' + this.value3;

            vm.resources.border.defaultValue = value;
            vm.element.internal_config.border = value;
          },
        },

        borderRadius: {
          name: 'borderRadius',
          defaultValue: '0 0 0 0',
          min: '0',
          max: '360',
          labelDesc: 'borderRadius',
          callback: function() {

            let value = this.v1 + 'px ' + this.v2 + 'px ' + this.v3 + 'px ' + this.v4 + 'px';

            vm.resources.borderRadius.defaultValue = value;
            vm.element.internal_config.borderRadius = value;
          },
        },

        backgroundColorContainer: {
          name: 'backgroundColorContainer',
          defaultValue: '#ffffff',
          gradient: true,
          labelDesc: 'bg-color-container',
          callback: function() {
            vm.resources.backgroundColorContainer.defaultValue = this.colorValue;
            vm.element.internal_config.backgroundColorContainer = this.colorValue;
          },
        },

        borderContainer: {
          name: 'borderContainer',
          defaultValue: '1px solid black',
          min: '0',
          max: '50',
          labelDesc: 'border',
          callback: function() {
            let value = this.value + 'px ' + this.value2 + ' ' + this.value3;

            vm.resources.borderContainer.defaultValue = value;
            vm.element.internal_config.borderContainer = value;
          },
        },

        borderRadiusContainer: {
          name: 'borderRadiusContainer',
          defaultValue: '0 0 0 0',
          min: '0',
          max: '360',
          labelDesc: 'borderRadiusContainer',
          callback: function() {

            let value = this.v1 + 'px ' + this.v2 + 'px ' + this.v3 + 'px ' + this.v4 + 'px';

            vm.resources.borderRadiusContainer.defaultValue = value;
            vm.element.internal_config.borderRadiusContainer = value;
          },
        },

        icon: {
          name: 'icon',
          defaultIcon: '',
          defaultPosition: 'left',
          labelDesc: 'icon',
          callback: function() {

            vm.resources.icon.defaultIcon = this.iconSelected;
            vm.resources.icon.defaultPosition = this.position;

            vm.element.internal_config.icon = this.iconSelected;
            vm.element.internal_config.iconPosition = this.position;

            vm.element.buildIcon();
          },
        },

        text: {
          name: 'text',
          defaultValue: '',
          labelDesc: 'accordion-headline',
          canRemove: false,
          callback: function() {
            vm.resources.text.defaultValue = this.value;
            vm.element.internal_config.text = this.value;

            vm.element.internal_config.backgroundColor = vm.resources.backgroundColor.defaultValue;
          },
        },

        textStyle: {
          name: 'textStyle',
          defaultFamily: '',
          defaultSize: '',
          showSizeMobile: true,
          shitOptions: true,
          defaultSizeMobile: '',
          defaultColor: '',
          defaultAlign: '',
          defaultWeight: '',
          defaultStroke: '',
          defaultStyle: '',
          labelDesc: 'textStyle',
          callback: function() {

            vm.resources.textStyle.defaultFamily = this.family;
            vm.element.internal_config.textStyle.family = this.family;

            vm.resources.textStyle.defaultSize = this.size + 'px';
            vm.element.internal_config.textStyle.size = this.size + 'px';

            vm.resources.textStyle.defaultSizeMobile = this.sizeMobile + 'px';
            vm.element.internal_config.textStyle.sizeMobile = this.sizeMobile + 'px';

            vm.resources.textStyle.defaultColor = this.color;
            vm.element.internal_config.textStyle.color = this.color;

            vm.resources.textStyle.defaultAlign = this.align;
            vm.element.internal_config.textStyle.align = this.align;

            vm.resources.textStyle.defaultWeight = this.weight;
            vm.element.internal_config.textStyle.weight = this.weight;

            vm.resources.textStyle.defaultStyle = this.style;
            vm.element.internal_config.textStyle.style = this.style;

            vm.resources.textStyle.defaultStroke = this.stroke;
            vm.element.internal_config.textStyle.stroke = this.stroke;
          },
        },

        enableLineBreak: {
          name: 'enableLineBreak',
          defaultValue: true,
          labelDesc: 'place-menu-enable-line-break',
          callback: function() {
            vm.resources.enableLineBreak.defaultValue = this.value;
            vm.element.internal_config.enableLineBreak = this.value;
          }
        },

        positionContainer: {
          name: 'positionContainer',
          defaultValue: 'start-menu',
          defaultOptions: [
            {
              name: 'start-menu',
              value: 'start-menu'
            },
            {
              name: 'start-menu-item',
              value: 'start-menu-item'
            },
            {
              name: 'width-full',
              value: 'width-full'
            }
          ],
          labelDesc: 'settings-start-menu-item',
          callback: function() {
            vm.resources.positionContainer.defaultValue = this.value;
            vm.element.internal_config.positionContainer = this.value;

            vm.element.internal_config.widthContainerFull = this.value === 'width-full';
          }
        },

        typeOpenContainer: {
          name: 'typeOpenContainer',
          defaultValue: 'type-open-container',
          defaultOptions: [
            {
              name: 'type-open-container-by-click',
              value: 'by-click'
            },
            {
              name: 'type-open-container-by-hover',
              value: 'by-hover'
            }
          ],
          labelDesc: 'type-open-container',
          callback: function() {
            vm.resources.typeOpenContainer.defaultValue = this.value;
            vm.element.internal_config.typeOpenContainer = this.value;
          }
        },

        leftMargin: {
          name: "leftMargin",
          defaultValue: 0,
          min: 0,
          max: 50,
          labelDesc: "left-margin",
          callback: function() {
            vm.resources.leftMargin.defaultValue = this.value;
            vm.element.internal_config.leftMargin = this.value;
          }
        },

        bottomMargin: {
          name: "bottomMargin",
          defaultValue: 0,
          min: 0,
          max: 50,
          labelDesc: "bottom-margin",
          callback: function() {
            vm.resources.bottomMargin.defaultValue = this.value;
            vm.element.internal_config.bottomMargin = this.value;
          }
        },

        padding: {
          name: 'padding',
          defaultLeft: '15',
          defaultTop: '15',
          defaultRight: '15',
          defaultBottom: '15',
          min: '0',
          max: '100',
          labelDesc: 'padding',
          callback: function() {
            vm.resources.padding.defaultLeft = this.l;
            vm.element.internal_config.paddingLeft = this.l + 'px';

            vm.resources.padding.defaultTop = this.t;
            vm.element.internal_config.paddingTop = this.t + 'px';

            vm.resources.padding.defaultRight = this.r;
            vm.element.internal_config.paddingRight = this.r + 'px';

            vm.resources.padding.defaultBottom = this.b;
            vm.element.internal_config.paddingBottom = this.b + 'px';
          },
        },
      }
    };
  },
  methods: {
    setValuesData(data) {
      this.element = data;

      this.resources.text.defaultValue = data.internal_config.text;

      this.resources.maxWidth.defaultValue = parseInt(data.internal_config.maxWidth);
      this.resources.height.defaultValue = parseInt(data.internal_config.height);
      this.resources.heightContainer.defaultValue = parseInt(data.internal_config.heightContainer);
      this.resources.widthContainer.defaultValue = parseInt(data.internal_config.widthContainer);

      this.resources.border.defaultValue = data.internal_config.border;
      this.resources.borderRadius.defaultValue = data.internal_config.borderRadius;
      this.resources.backgroundColor.defaultValue = data.internal_config.backgroundColor;

      this.resources.backgroundColorHover.defaultValue = data.internal_config.backgroundColorHover;
      this.resources.textColorHover.defaultValue = data.internal_config.textColorHover;

      this.resources.backgroundColorSelected.defaultValue = data.internal_config.backgroundColorSelected;
      this.resources.textColorSelected.defaultValue = data.internal_config.textColorSelected;

      this.resources.textStyle.defaultFamily = data.internal_config.textStyle.family;
      this.resources.textStyle.defaultSize = data.internal_config.textStyle.size;
      this.resources.textStyle.defaultSizeMobile = data.internal_config.textStyle.sizeMobile;
      this.resources.textStyle.defaultColor = data.internal_config.textStyle.color;
      this.resources.textStyle.defaultAlign = data.internal_config.textStyle.align;
      this.resources.textStyle.defaultWeight = data.internal_config.textStyle.weight;
      this.resources.textStyle.defaultStyle = data.internal_config.textStyle.style;
      this.resources.textStyle.defaultStroke = data.internal_config.textStyle.stroke;

      this.resources.borderContainer.defaultValue = data.internal_config.borderContainer;
      this.resources.borderRadiusContainer.defaultValue = data.internal_config.borderRadiusContainer;
      this.resources.backgroundColorContainer.defaultValue = data.internal_config.backgroundColorContainer;

      this.resources.icon.defaultIcon = data.internal_config.icon;
      this.resources.icon.defaultPosition = data.internal_config.iconPosition;

      this.resources.bottomMargin.defaultValue = parseInt(data.internal_config.bottomMargin);
      this.resources.leftMargin.defaultValue = parseInt(data.internal_config.leftMargin);
      this.resources.positionContainer.defaultValue = data.internal_config.positionContainer;
      this.resources.typeOpenContainer.defaultValue = data.internal_config.typeOpenContainer;

      this.resources.padding.defaultLeft = parseInt(data.internal_config.paddingLeft);
      this.resources.padding.defaultTop = parseInt(data.internal_config.paddingTop);
      this.resources.padding.defaultRight = parseInt(data.internal_config.paddingRight);
      this.resources.padding.defaultBottom = parseInt(data.internal_config.paddingBottom);

      // this.resources.widthContainer.defaultValueChecked = data.internal_config.widthContainerFull;

      this.resources.link.defaultValue = data.internal_config.link;
      this.resources.enableOnlyLink.defaultValue = data.internal_config.enableOnlyLink;
      this.resources.enableLineBreak.defaultValue = data.internal_config.enableLineBreak;
    },
    getValuesData() {
      return this.resources;
    }
  },
};
</script>



// WEBPACK FOOTER //
// src/components/editor/apps/BigMenu/PlaceMenu/Resources.vue